import { atom } from 'jotai/index';
import { fetchSavedViews } from '~/service/savedViewService';
import { userAtom } from '~/atoms/user';
import { linePlanEntityAtom } from '~/atoms/linePlanEntity';
export const refreshSavedViewsAtom = atom(false);
const baseSavedViewsAtom = atom(async (get) => {
    get(refreshSavedViewsAtom);
    const user = await get(userAtom);
    if (user?.email) {
        return await fetchSavedViews(user.email);
    }
    return [];
});
const removedSavedViewIdsAtom = atom(new Set());
export const savedViewsAtom = atom(async (get) => {
    const baseData = await get(baseSavedViewsAtom);
    const removedIds = get(removedSavedViewIdsAtom);
    return baseData.filter((savedView) => !removedIds.has(savedView.projectId));
});
export const filteredSavedViewsAtom = atom(async (get) => {
    const allViews = await get(savedViewsAtom);
    const linePlanEntity = get(linePlanEntityAtom);
    return allViews.filter((view) => {
        if (!view.metadata?.linePlanEntityType)
            return false;
        return view.metadata.linePlanEntityType === linePlanEntity;
    });
});
export const removeSavedViewAtom = atom(null, (get, set, savedViewId) => {
    const currentRemovedIds = get(removedSavedViewIdsAtom);
    const newRemovedIds = new Set(currentRemovedIds);
    newRemovedIds.add(savedViewId);
    set(removedSavedViewIdsAtom, newRemovedIds);
});
